import { type GridPosition } from '../state/types';

export function isSameCell(
  targetCell: GridPosition,
  selectedCell: GridPosition
): boolean {
  return (
    targetCell.row.index === selectedCell.row.index &&
    targetCell.col.index === selectedCell.col.index
  );
}
